import api from "../api";

export const getAirlines = (params) =>
  api.get("/airline", { params });

export const addAirline = (payload) => api.post("/airline/add", payload);

export const updateAirline = (id, payload) =>
  api.post(`/airline/edit/${id}`, payload);

export const deleteAirline = (id) =>
  api.post(`/airline/delete/${id}`);

export const changeAirlineStatus = (id, active) =>
  api.post(`/airline/change_status/${id}`, { active });

